import { getLocalStorage, setLocalStorage } from './local-storage';

const { scrollToElement } = require('./dom-utils');
const { switchTab } = require('./tabs');

// Used to land on a specific element coming back from another page
export const landToElement = {
  name: 'landToElement',
  get: () => getLocalStorage(landToElement.name),
  /**
   *
   * @param {String} elementId - the CSS id of the DOM element we want to land on
   * @param {String[]} fallbackElementClassname - optional: array of fallback CSS class
   * @param {Number} tabId - optional, the CSS id of the tab we want to land on (if not given will be the currently active tab)
   * @param {Object} responsiveOffset - optionally it can be set on the local storage
   */
  set: ({ elementId, fallbackElementClassname, tabId, responsiveOffset }) => {
    const activeTabId = document.querySelector('.j-tabs-button[data-state="active"]')?.getAttribute('id');
    setLocalStorage(landToElement.name, {
      elementId,
      tabId: tabId || activeTabId,
      fallbackElementClassname,
      responsiveOffset,
    });
  },
  land: ({ elementId, tabId = '1', fallbackElementClassname, responsiveOffset }) => {
    const hpTabs = document.querySelector('.j-hp-tabs');
    const hpTabsComputedStyle = hpTabs ? window.getComputedStyle(hpTabs) : undefined;
    const hpTabsIsShown = hpTabsComputedStyle && hpTabsComputedStyle.display !== 'none';

    if (hpTabsIsShown) {
      // On mobile & tablet portrait just switch HP tabs
      const tabToActivate = hpTabs.querySelector(`[id="${tabId}"]`);
      const activeTabId = hpTabs.querySelector('[data-state="active"]').getAttribute('id');
      if (tabId !== activeTabId) {
        switchTab(tabToActivate);
      }
    }
    const $elementToScroll =
      document.getElementById(elementId) || document.querySelectorAll(fallbackElementClassname)[0];

    if ($elementToScroll) {
      scrollToElement({ $element: $elementToScroll, responsiveOffset, delay: 800 });
    }
    landToElement.clean();
  },
  clean: () => {
    localStorage.removeItem(landToElement.name);
    history.replaceState(null, null, ' '); // It cleans the url from the hash
  },
};
